import {
  Link as MuiLink,
  LinkProps as MuiLinkProps,
  useTheme
} from "@mui/material";
import { AllHTMLAttributes, forwardRef } from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps
} from "react-router-dom";


export type LinkProps = MuiLinkProps & Omit<RouterLinkProps, "to">

/** LINK OVERRIDE,
 * forwards mui links to react-router-6 links
 * (use mui link props with react-router links)
 */
export const LinkBehavior = forwardRef<
 HTMLAnchorElement,
 Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }
>((props, ref) => {
  const { href, ...other } = props;
  return <RouterLink ref={ ref } to={ href } { ...other } />;
});
LinkBehavior.displayName = "Link";

export const Link = forwardRef<
  HTMLAnchorElement,
  AllHTMLAttributes<HTMLAnchorElement> & MuiLinkProps & Omit<RouterLinkProps, "to"> // aka, LinkProps
>(({ children,sx, ...props }, ref) => {
  const theme = useTheme();

  return (
    <MuiLink
      ref={ ref }
      target={ props.target || "_self" }
      lineHeight="100%"
      { ...props }
      sx={ {
        ":hover": {
          color: theme.customColors.textPrimary,
          transition: "all 0.2s ease"
        },
        color:theme.customColors.systemSecondary01,
        gap: "0.5rem",
        fontWeight: 500,
        hover: { textDecoration: "none" },
        textDecoration: "none",
        ...sx
      } }
    >
      { children }
    </MuiLink>
  );
});
Link.displayName = "Link";
